import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthProvider";

export const RequireAuth = ({ children }) => {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to={"/"} />;
  } else {
    return children;
  }
};
